import { zodResolver } from '@hookform/resolvers/zod'
import axios from 'axios'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import { z } from 'zod'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { useHeadManager } from '@/lib/headManagerProvider'

const contactSchema = z.object({
  nome: z.string().min(3),
  email: z.string().email(),
  mensagem: z.string().min(5),
})

type ContactForm = z.infer<typeof contactSchema>

export function Contact() {
  const { setTitle } = useHeadManager()
  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm<ContactForm>({
    resolver: zodResolver(contactSchema),
  })

  useEffect(() => {
    setTitle('Contato')
  }, [setTitle])

  async function onSubmit(data: ContactForm) {
    try {
      await axios.post('Contact/sendMail', data)
      toast.success('Mensagem enviada com sucesso!')
      reset()
    } catch (err) {
      toast.error('Erro ao enviar mensagem.')
    }
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="mx-auto mt-20 w-full max-w-3xl space-y-6 px-4"
    >
      <div className="space-y-2">
        <Label htmlFor="nome">Nome</Label>
        <Input id="nome" {...register('nome')} className="w-full" />
      </div>

      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          {...register('email')}
          className="w-full"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="mensagem">Mensagem</Label>
        <Textarea
          id="mensagem"
          rows={10}
          {...register('mensagem')}
          className="w-full"
        />
      </div>

      <div className="flex justify-center">
        <Button type="submit" disabled={isSubmitting}>
          Enviar Mensagem
        </Button>
      </div>
    </form>
  )
}
